import React from 'react';

const h = React.createElement;

/**
 * Flat recessed panel inside a Card. No border, no shadow.
 *
 * @param {object} p
 * @param {React.ReactNode} [p.children]
 * @param {React.CSSProperties} [p.style]
 */
export function Inset({ children, style }) {
  return h('div', { style: { background: 'var(--inset)', borderRadius: 10, padding: '12px 14px', ...style } }, children);
}
